/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_TitleInputs */

const en_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work Order Publish`)
};

const fr_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication de l’ordre de travail`)
};

const de_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsauftrag veröffentlichen`)
};

const it_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione dell'ordine di lavoro`)
};

const ru_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать заявку на выполнение работ`)
};

const es_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de órdenes de trabajo`)
};

const zh_cn2_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布工单`)
};

const ja_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業指示書の公開`)
};

const hi_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य आदेश प्रकाशित करें`)
};

const pt_pt2_work_order_publish_title = /** @type {(inputs: Work_Order_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação da Ordem de Serviço`)
};

/**
* | output |
* | --- |
* | "Work Order Publish" |
*
* @param {Work_Order_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_title = /** @type {((inputs?: Work_Order_Publish_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_title(inputs)
	if (locale === "de") return de_work_order_publish_title(inputs)
	if (locale === "it") return it_work_order_publish_title(inputs)
	if (locale === "ru") return ru_work_order_publish_title(inputs)
	if (locale === "es") return es_work_order_publish_title(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_title(inputs)
	if (locale === "ja") return ja_work_order_publish_title(inputs)
	if (locale === "hi") return hi_work_order_publish_title(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_title(inputs)
	return en_work_order_publish_title(inputs)
});